import {forwardRef} from 'react';
import type {ForwardedRef, HTMLAttributes, PropsWithChildren} from 'react';

import classNames from 'classnames';
import {type Placement} from '@react-types/overlays';

import styles from './dropdown-container.module.css';

export enum BorderRadiusSize {
    Medium = 'medium',
    Large = 'large'
}

type Props = HTMLAttributes<HTMLDivElement> & {
    isOpen?: boolean;
    borderRadiusSize: BorderRadiusSize;
    placement?: Placement;
};

const getDropdownMarginClassName = (placement?: Placement) => {
    if (!placement) {
        return undefined;
    }

    if (placement.startsWith('top')) {
        return 'mb';
    }

    if (placement.startsWith('bottom')) {
        return 'mt';
    }

    if (placement.startsWith('left')) {
        return 'mr';
    }

    if (placement.startsWith('right')) {
        return 'ml';
    }

    return undefined;
};

export const DropdownContainer = forwardRef(({
    className,
    children,
    borderRadiusSize,
    ...props
}: PropsWithChildren<Props>, ref: ForwardedRef<HTMLDivElement>) => {
    const marginClassName = getDropdownMarginClassName(props.placement);
    return (
        <div
            {...props}
            ref={ref}
            className={classNames(styles.root, className, styles[borderRadiusSize],
                marginClassName && styles[marginClassName],
            )}
        >
            {children}
        </div>
    );
});

DropdownContainer.displayName = 'Dropdown';
